import { useState, useEffect } from 'react';
import { API_URL } from '../config';

const useTestimonials = (cursoId) => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    const fetchTestimonials = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_URL}/api/testimonios?cursoId=${cursoId}`, { signal });
        if (!res.ok) throw new Error('Error fetching course testimonials');
        const data = await res.json();

        const items = (data && Array.isArray(data.items)) ? data.items : [];

        if (!signal.aborted) {
          setTestimonials(items);
        }
      } catch (err) {
        if (err.name === 'AbortError') return;
        console.error(err);
        if (!signal.aborted) {
          setError(err.message);
        }
      } finally {
        if (!signal.aborted) {
          setLoading(false);
        }
      }
    };

    if (cursoId !== null && cursoId !== undefined) {
      fetchTestimonials();
    } else {
      setLoading(false);
    }

    return () => controller.abort();
  }, [cursoId]);

  return { testimonials, loading, error };
};

export default useTestimonials;
